import { mount } from 'svelte'
import CouponForm from '@/components/coupons/Form.svelte'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('coupons-form-app')
  if (el) {
    mount(
      CouponForm,
      {
        target: el,
        props: {
          initialCoupon: el.dataset.coupon
        },
      })
  }
})
